import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import PaidIcon from "@mui/icons-material/Paid";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useNavigate } from "react-router";
import ChangePassword from "./security/ChangePassword";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import { getAgentType } from "../actions/agent";

const secondaryListItems = [
	//{ text: "Change Password", icon: <PasswordRoundedIcon /> },
	//{ text: "Security", icon: <SecurityRoundedIcon /> },
	{ text: "Settings", icon: <SettingsRoundedIcon /> },
];

export default function MenuContent({ token }) {
	const navigate = useNavigate();
	const [selectIndex, setSelectIndex] = React.useState(0);
	const [mainListItems, setMainListItems] = React.useState([]);

	const gotoNavigate = (ruta, index) => {
		setSelectIndex(index);
		navigate(ruta);
	};

	React.useEffect(() => {
		getAgentType(token, (res) => {
			if (!res.error) {
				if (res.data) {
					setMainListItems([
						{ text: "Home", icon: <HomeRoundedIcon />, ruta: "/admin" },
						//{ text: 'Deposit', icon: <LocalAtmIcon />, ruta: "/withdrawal" },
						//{ text: "Withdrawal", icon: <PaidIcon />, ruta: "/withdrawal" },
						//{ text: 'Transfers', icon: <MoveDownIcon />, ruta: "/withdrawal" },
						{ text: "Account Deposits", icon: <AssessmentIcon />, ruta: "/reports/agentdeposits" },
						{ text: "Account Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/agentwithdrawals" },
						{ text: "Account Transfers", icon: <TransferWithinAStationIcon />, ruta: "/reports/agenttransfersreport" },
						//{ text: "Transfer Report", icon: <AssessmentIcon />, ruta: "/reports/agenttransfersreport" },
						{ text: "Customers", icon: <PeopleRoundedIcon />, ruta: "/customers" },
						{ text: "Customer Deposits", icon: <AssessmentIcon />, ruta: "/reports/customerdeposits" },
						{ text: "Customer Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/customerwithdrawals" },
						{ text: "Agents List", icon: <AssessmentIcon />, ruta: "/admin/agentslist" },
						//{ text: "Withdrawal Requests", icon: <AssessmentIcon />, ruta: "/reports/withdrawalsrequest" },
					]);
				} else {
					setMainListItems([
						{ text: "Home", icon: <HomeRoundedIcon />, ruta: "/admin" },
						//{ text: 'Deposit', icon: <LocalAtmIcon />, ruta: "/withdrawal" },
						//{ text: "Withdrawal", icon: <PaidIcon />, ruta: "/withdrawal" },
						//{ text: 'Transfers', icon: <MoveDownIcon />, ruta: "/withdrawal" },
						{ text: "Account Deposits", icon: <AssessmentIcon />, ruta: "/reports/agentdeposits" },
						{ text: "Account Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/agentwithdrawals" },
						{ text: "Account Transfers", icon: <TransferWithinAStationIcon />, ruta: "/reports/agenttransfersreport" },
						//{ text: "Transfer Report", icon: <AssessmentIcon />, ruta: "/reports/agenttransfersreport" },
						{ text: "Customers", icon: <PeopleRoundedIcon />, ruta: "/customers" },
						{ text: "Customer Deposits", icon: <AssessmentIcon />, ruta: "/reports/customerdeposits" },
						{ text: "Customer Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/customerwithdrawals" },
						//{ text: "Withdrawal Requests", icon: <AssessmentIcon />, ruta: "/reports/withdrawalsrequest" },
					]);
				}
			} else {
				setMainListItems([
					{ text: "Home", icon: <HomeRoundedIcon />, ruta: "/admin" },
					//{ text: 'Deposit', icon: <LocalAtmIcon />, ruta: "/withdrawal" },
					//{ text: "Withdrawal", icon: <PaidIcon />, ruta: "/withdrawal" },
					//{ text: 'Transfers', icon: <MoveDownIcon />, ruta: "/withdrawal" },
					{ text: "Account Deposits", icon: <AssessmentIcon />, ruta: "/reports/agentdeposits" },
					{ text: "Account Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/agentwithdrawals" },
					{ text: "Account Transfers", icon: <TransferWithinAStationIcon />, ruta: "/reports/agenttransfersreport" },
					//{ text: "Transfer Report", icon: <AssessmentIcon />, ruta: "/reports/agenttransfersreport" },
					{ text: "Customers", icon: <PeopleRoundedIcon />, ruta: "/customers" },
					{ text: "Customer Deposits", icon: <AssessmentIcon />, ruta: "/reports/customerdeposits" },
					{ text: "Customer Withdrawals", icon: <AssessmentIcon />, ruta: "/reports/customerwithdrawals" },
					//{ text: "Withdrawal Requests", icon: <AssessmentIcon />, ruta: "/reports/withdrawalsrequest" },
				]);
			}
		});
	}, []);

	return (
		<>
			{mainListItems ? (
				<Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
					<List dense>
						{mainListItems.map((item, index) => (
							<ListItem key={index} disablePadding sx={{ display: "block" }}>
								<ListItemButton selected={index === selectIndex} onClick={() => gotoNavigate(item.ruta, index)}>
									<ListItemIcon>{item.icon}</ListItemIcon>
									<ListItemText primary={item.text} />
								</ListItemButton>
							</ListItem>
						))}
					</List>
					<List dense>
						<ListItem key={5} disablePadding sx={{ display: "block" }}>
							<ListItemButton selected={5 === selectIndex} onClick={() => gotoNavigate("/changepassword", 5)}>
								<ListItemIcon>
									<PasswordRoundedIcon />
								</ListItemIcon>
								<ListItemText primary={"Change Password"} />
							</ListItemButton>
						</ListItem>
						<ListItem key={6} disablePadding sx={{ display: "block" }}>
							<ListItemButton selected={6 === selectIndex} onClick={() => gotoNavigate("/security", 6)}>
								<ListItemIcon>
									<SecurityRoundedIcon />
								</ListItemIcon>
								<ListItemText primary={"Security"} />
							</ListItemButton>
						</ListItem>
						<ListItem key={7} disablePadding sx={{ display: "block" }}>
							<ListItemButton selected={7 === selectIndex} onClick={() => gotoNavigate("/settings", 7)}>
								<ListItemIcon>
									<SettingsRoundedIcon />
								</ListItemIcon>
								<ListItemText primary={"Settings"} />
							</ListItemButton>
						</ListItem>
					</List>
				</Stack>
			) : null}
		</>
	);
}
